<template>
  <div>
    <b-alert v-if="card_error" variant="danger" show style="font-size: 0.7rem;" class="p-2">{{card_error}}</b-alert>
    <div ref="card"></div>
  </div>
</template>

<script>

  let stripe = null;
  let card = null;
  let elements = null;
  if(window.Stripe === undefined) {
    console.error('Stripe V3 library not loaded!')
  } else {
    stripe = window.Stripe(process.env.VUE_APP_STRIPE_PUBLIC_KEY);
    elements = stripe.elements();
  }

  export default {
    name: 'StripeCardElement',
    data() {
      return {
        card_error: null,
      };
    },
    methods: {},
    watch: {},
    mounted: function () {
      if(elements) {
        if(!card) {
          card = elements.create('card');
        }
        card.mount(this.$refs.card);
        window.stripeCardInstance = {stripe, card, elements};
      }
    }
  }
</script>
